import React, { useState, useEffect } from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import Home from './components/Pages/Home';
import ProductDetails from './components/Pages/ProductDetails';
import AboutUs from './components/Pages/AboutUs';
import ContactUs from './components/Pages/ContactUs';
import Categories from './components/Pages/Categories';
import CategoryDetails from './components/Pages/CategoryDetails';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import { Product } from './types';
import { fetchCategoryProductsByName } from './services/api';
import ScrollToTop from './components/Layout/ScrollToTop';

const App: React.FC = () => {
	const [products, setProducts] = useState<Product[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	const fetchProducts = async (categoryName: string) => {
		try {
			setLoading(true);
			const data = await fetchCategoryProductsByName(categoryName);
			setProducts(data);
			setError(null); // Clear previous errors
		} catch (err) {
			console.error(err);
			setError('Failed to load products');
		} finally {
			setLoading(false);
		}
	};

const CategoryDetailsWrapper = () => {
	const { categoryName } = useParams<{ categoryName?: string }>();
	const [products, setProducts] = useState<Product[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

useEffect(() => {
	if (categoryName) {
		const fetchProducts = async () => {
			try {
				setLoading(true);
				const data = await fetchCategoryProductsByName(categoryName);
				console.log('Fetched products:', data); // Debug log
				setProducts(data);
			} catch (err) {
				console.error('Error fetching category products:', err);
				setError('Failed to load products');
			} finally {
				setLoading(false);
			}
		};

		fetchProducts();
	}
}, [categoryName]);

	return (
		<CategoryDetails
			products={products}
			loading={loading}
			error={error}
			categoryName={categoryName || ''}
		/>
	);
};

	return (
		<>
			<ScrollToTop />
			<Header />
			<main style={{ minHeight: '80vh' }}>
				<Routes>
					<Route
						path="/"
						element={<Home />}
					/>
					<Route
						path="/categories/:categoryName/:fullProduct"
						element={<ProductDetails />}
					/>
					<Route
						path="/categories/:categoryName"
						element={<CategoryDetailsWrapper />}
					/>
					<Route
						path="/categories"
						element={<Categories isHomePage />}
					/>
					<Route
						path="/about-us"
						element={<AboutUs />}
					/>
					<Route
						path="/contact-us"
						element={<ContactUs />}
					/>
					<Route
						path="*"
						element={<h1>404 - Page Not Found</h1>}
					/>
				</Routes>
			</main>
			<Footer />
		</>
	);
};

export default App;
